import React from "react"
import { getSearchedFood } from "../../../service/CalculatorService"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import CalculatorSearchInputStyle from "./CalculatorSearchInputStyle.module.css"
import SearchResultDropdown from "../searchResultDropdown/SearchResultDropdown"
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons/faTimesCircle"
import SearchResultContent from "../searchResultContent/SearchResultContent"
import translate, { keys } from "../../../../../translation/translator"
import CalculatorMapIcon from "../../../../../assets/images/find-on-map.svg"

class CalculatorSearchInput extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      food: [],
      searchWord: "",
      newFood: {},
      value: 250,
      glPerServe: 0,
    }
  }

  componentDidMount() {
    this.searchFoodResults()
  }
  handleGetMeal = id => {
    let newFood = this.state.food.filter(food => food._id === id)
    this.setState({
      newFood: newFood[0],
      food: [],
      glPerServe: (
        (newFood[0].giMean *
          ((newFood[0].carbsForServeSize / newFood[0].serveSize) *
            newFood[0].serveSize)) /
        100
      ).toFixed(1),
      value: newFood[0].serveSize,
      searchWord: `${newFood[0].name}`,
    })
  }
  handleDeleteFood = () => {
    this.setState({ newFood: {}, glPerServe: 0, value: 250, searchWord: "" })
  }
  searchFoodResults = keyword => {
    getSearchedFood(keyword).then(food => {
      this.setState({ food })
    })
  }
  keyPressed = event => {
    const { food } = this.state
    if (event.key === "Enter" && food.length > 0) {
      this.handleGetMeal(food[0]._id)
    }
  }
  handleSearch = ({ target }) => {
    this.setState({ searchWord: target.value })
    target.value
      ? this.searchFoodResults(target.value)
      : this.searchFoodResults()
    if (target.value === "") {
      this.handleDeleteFood()
    }
  }
  handleClearInput = () => {
    this.setState({ searchWord: "", food: [] })
  }
  handleInputValueChange = (event, value) => {
    const { carbsForServeSize, serveSize, giMean } = this.state.newFood
    let sliderValue
    let newCarbs
    let glycemicIndex

    if (value === undefined) {
      this.setState({
        value: event.target.value,
      })
      sliderValue = parseInt(event.target.value)
      if (event.target.value > 500) {
        this.setState({ value: 500 })
        sliderValue = 500
      }
      if (event.target.value < 0) {
        this.setState({ value: 0 })
        sliderValue = 0
      }
    } else {
      this.setState({
        value: value,
      })
    }

    if (value === undefined) {
      newCarbs = (carbsForServeSize / serveSize) * sliderValue
    } else {
      newCarbs = (carbsForServeSize / serveSize) * value
    }
    glycemicIndex = (giMean * newCarbs) / 100
    this.setState({ glPerServe: glycemicIndex.toFixed(1) })
  }
  render() {
    const { locale } = this.props
    const { food, searchWord, glPerServe, value, newFood } = this.state
    const { handleSearch } = this
    return (
      <div id="calculator" className={CalculatorSearchInputStyle.holder}>
        <h1 className={CalculatorSearchInputStyle.title}>
          {translate(keys.INPUT_SEARCH_TITLE, locale)}
        </h1>

        <div className={CalculatorSearchInputStyle.input_holder}>
          <input
            className={food.length > 0 ? CalculatorSearchInputStyle.shown : ""}
            type="text"
            onKeyPress={this.keyPressed}
            value={searchWord}
            placeholder={translate(keys.INPUT_SEARCH_PLACEHOLDER, locale)}
            onChange={handleSearch}
          />
          <img
            alt="search-location-icon"
            className={CalculatorSearchInputStyle.search_icon}
            src={CalculatorMapIcon}
          />
          {searchWord.length > 0 ? (
            <FontAwesomeIcon
              icon={faTimesCircle}
              onClick={this.handleClearInput}
              className={
                this.state.newFood.name
                  ? CalculatorSearchInputStyle.none
                  : CalculatorSearchInputStyle.clear_icon
              }
            />
          ) : null}
          {this.state.newFood.name ? (
            <FontAwesomeIcon
              className={CalculatorSearchInputStyle.clear_icon}
              icon={faTimesCircle}
              onClick={this.handleDeleteFood}
            />
          ) : (
            ""
          )}
          <span
            className={
              food.length > 0
                ? CalculatorSearchInputStyle.line
                : CalculatorSearchInputStyle.none
            }
          />
          <SearchResultDropdown
            locale={locale}
            handleSearch={handleSearch}
            food={food}
            handleGetMeal={id => this.handleGetMeal(id)}
          />
          <SearchResultContent
            locale={locale}
            searchWord={searchWord}
            handleInputValueChange={this.handleInputValueChange}
            glPerServe={glPerServe}
            newFood={newFood}
            value={value}
          />
        </div>
      </div>
    )
  }
}

CalculatorSearchInput.propTypes = {}

export default CalculatorSearchInput
